import {
  DataTableFilter,
  ExpensesExpensableFilter,
  FilterType,
} from 'generated/resources/datatable.graphql'
import { ExpensePageFinanceCustomCategoryFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { BaseFilterProps } from './types'
import { trackFilters } from './utils'

type Props = BaseFilterProps & {
  categories: ExpensePageFinanceCustomCategoryFragment[]
}
const categoryFilter = ({
  categories,
  expensesContext,
  initialFilterValues,
}: Props): DataTableFilter<ExpensesExpensableFilter> => {
  const options = categories.map((cat) => ({
    label: cat.label,
    value: cat.identifier,
  }))

  return {
    type: FilterType.String,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
        value: initialFilterValues.category ? [initialFilterValues.category] : [],
      },
    ],
    onUpdateValue: () => {
      trackFilters('category', expensesContext)
    },
    identifier: 'expensesList.categoryFilter',
    path: 'category',
    title: i18n.t('expenses_v2.list.header.category'),
    default: !!initialFilterValues.category,
  }
}

export default categoryFilter
